import React from "react";
import "./AddModal.css";
import { Modal } from "react-bootstrap";
import { useTranslation } from "../../../../contexts/TranslationContext";
import Cookies from "js-cookie";

const GlobalModal = ({
  title,
  subtitle,
  globalModal,
  onClose,
  onClick,
  showOneBtn,
  oneBtnText,
  disableClose,
}) => {
  const { t } = useTranslation();
  const Lang = Cookies.get("preferred_language") || "en";

  return (
    <Modal
      show={globalModal}
      onHide={() => {
        onClose();
      }}
      backdrop={disableClose ? "static" : true}
      keyboard={!disableClose}
      className={`global-modal ${Lang === "ar" ? "rtl" : "ltr"}`}
      centered
    >
      <Modal.Body className="global-modal-body">
        <div className="global-modal-title">{title}</div>
        <div className="global-modal-desc">{subtitle}</div>
        <div className="global-modal-btns">
          {!showOneBtn && (
            <div
              className={`global-modal-btn ${
                oneBtnText ? "" : "global-modal-btn-margin"
              }`}
              onClick={onClick}
            >
              {t("yesSure")}
            </div>
          )}
          <div
            className={`global-modal-btn ${
              oneBtnText ? "" : "global-modal-btn-margin"
            }`}
            onClick={() => {
              onClose();
            }}
          >
            {!showOneBtn ? t("No") : oneBtnText}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GlobalModal;
